// --- Core ---
import {createContext} from "react";
import {omit} from 'underscore';
// --- SaniQ ---
import {fetchAPI} from "api";
/**
 NOTE(Keune): Use snake_case for this state instead of CamelCase
 to allow easy merging of the API response into this state
 */

interface CorporateIdentity {
  logo_light_path: string;
  logo_dark_path: string;
  logo_app_light_path: string;
  logo_app_dark_path: string;
  favicon_path: string;
  product_name: string;
  dark_primary_main: string;
  dark_primary_contrast_text: string;
  dark_secondary_main: string
  dark_secondary_contrast_text: string;
  dark_text_primary: string;
  light_primary_main: string;
  light_primary_contrast_text: string;
  light_secondary_main: string;
  light_secondary_contrast_text: string;
  light_text_primary: string;
  primary_light: string;
  secondary_1: string;
  secondary_1_light: string;
  secondary_2: string;
  secondary_2_light: string;
  secondary_3: string;
  secondary_3_light: string;
}

const initialState: CorporateIdentity = {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  logo_light_path: require("../images/logo/praxis-light.svg").default,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  logo_dark_path: require("../images/logo/praxis-dark.svg").default,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  logo_app_light_path: require("images/logo/saniq_app_light.svg").default,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  logo_app_dark_path: require("images/logo/saniq_app_dark.svg").default,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  favicon_path: require('../images/logo/favicon.svg'),
  product_name: "SaniQ",
  dark_primary_main: "#1892C4",
  dark_primary_contrast_text: "#1b1b1b",
  dark_secondary_main: "#a4aebd",
  dark_secondary_contrast_text: "#1b1b1b",
  dark_text_primary: "#e8e8e8",
  light_primary_main: "#174B81",
  light_primary_contrast_text: "#f0f0f0",
  light_secondary_main: "#1892C4",
  light_secondary_contrast_text: "#ffffff",
  light_text_primary: "#1b1b1b",
  primary_light: "#97CDEC",
  secondary_1: "#F08DB4",
  secondary_1_light: "#F1B9CD",
  secondary_2: "#F5AB83",
  secondary_2_light: "#FACDB2",
  secondary_3: "#BFD462",
  secondary_3_light: "#E0EAB8"
};

function corporateIdentity(): Promise<CorporateIdentity> {
  const url = '/web/v1/tenants/corporate_identity';

  return fetchAPI(url, 'GET', null, {ignoreNotFound: true, withAuthentication: false})
    .then((response) => {
      const {attributes} = response.content.data;
      // Remove values with null
      const notNullAttributes = omit(attributes, (value) => (!value));

      return {...initialState, ...notNullAttributes};
    })
    .catch(() => initialState);
}
const CorporateIdentityContext = createContext<CorporateIdentity>(initialState);

export {
  CorporateIdentity,
  corporateIdentity,
  CorporateIdentityContext,
  initialState as defaultCorporateIdentity
};
